export const roomConstants = {
	KIND_ROOM: 'room',
	KIND_MEETING_ROOM: 'meeting_room',
};
